This indicates whether or not the candidate agrees to the provided privacy policy.
